<template>
  <div v-loading="dataLoading" class="legal-info">
    <div v-show="materialList.length > 0">
      <validation-component
        ref="legalFormRef"
        :validation-condition="legalCondition">
        <!-- 身份证有效期 -->
        <template slot="expire">
          <div class="expire-box">
            <RhcnDatepicker v-model="formData.effectiveDate"
                            :pickerOptions="pickerStartOptions"
                            type="date"
                            :format="'yyyy-MM-dd'">
            </RhcnDatepicker>
            <i class="el-icon-minus margin-left-3 margin-right-3" style="line-height: 32px"></i>
            <RhcnDatepicker v-model="formData.expireDate"
                            type="date"
                            :pickerOptions="pickerEndOptions"
                            :disabled="formData.longEffective"
                            :format="'yyyy-MM-dd'">
            </RhcnDatepicker>
            <div class="expire-long-box">
              <el-checkbox v-model="formData.longEffective" @change="handleLongEffective($event, 'longEffective')"></el-checkbox>
              <span class="margin-left-10">{{$t('message.user.longEffective')}}</span>
            </div>
          </div>
        </template>
        <!-- 营业执照有效期 -->
        <template slot="licenseExpire">
          <div class="expire-box">
            <RhcnDatepicker v-model="formData.blEffectiveDate"
                            :pickerOptions="pickerStartOptions"
                            type="date"
                            :format="'yyyy-MM-dd'">
            </RhcnDatepicker>
            <i class="el-icon-minus margin-left-3 margin-right-3" style="line-height: 32px"></i>
            <RhcnDatepicker v-model="formData.blExpireDate"
                            type="date"
                            :pickerOptions="pickerEndOptions"
                            :disabled="formData.blLongEffective"
                            :format="'yyyy-MM-dd'">
            </RhcnDatepicker>
            <div class="expire-long-box">
              <el-checkbox v-model="formData.blLongEffective" @change="handleLongEffective($event, 'blLongEffective')"></el-checkbox>
              <span class="margin-left-10">{{$t('message.user.longEffective')}}</span>
            </div>
          </div>
        </template>
        <!-- 实名信息 -->
        <template slot="material">
          <div class="material-box">
            <!-- <div>确保上传的图片文字清晰可见，最大不超过5M，支持JPG、PNG、BMP、</div> -->
            <div v-for="(item, index) in materialList" :key="index" class="material-item" :class="[item.fileUrl && `${item.materialFormat}` !== '2' ? 'dash-box' : '']">
              <RhcnUpload
                v-if="`${item.materialFormat}` !== '2'"
                :title="item.label"
                :fileList="item.fileList"
                :accept="item.accept"
                :on-change="onMaterialItemChange(index)"
                :on-remove="onMaterialItemRemove(index)">
              </RhcnUpload>
              <el-input v-else v-model="item.fileUrl" :placeholder="item.label"></el-input>
            </div>
          </div>
        </template>
      </validation-component>
      <div class="margin-top-20">
      <el-button
        style="width: 100%"
        type="primary"
        @click="onSubmit"
        >{{ $t("message.common.next") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import RhcnDatepicker from '@/components/form/datepicker.vue';
import { ShowWarningMessage } from '@/components/modal/tips/message-tips';
import { REQUIRED } from '@/components/validation/tool/validator';
import ValidationComponent from '@/components/validation/validation.vue';
import GlobalData from '@/utils/global/index';
import { getEnantiomericValue, initSelectedData } from '@/utils/tools/constant';
import { formatDateDisplay } from '@/utils/tools/time';
import { shallowClones, getFileNameFromUrl } from '@/utils/tools/utils.js';
import RhcnUpload from '@/views/account/information/supplement/upload/index.vue';
import { getMaterialInfoList, uploadMaterialUseTemplate } from '@/views/transfer/api/contact';

export default {
  components: {
    ValidationComponent,
    RhcnDatepicker,
    RhcnUpload,
  },
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dataLoading: false,
      legalCondition: [
        {
          key: 'name',
          name: 'message.user.legalPersonName',
          type: 'input',
          defValue: '',
          isShowStar: true,
          rule: [REQUIRED],
          maxLength: 100,
          placeholder: this.$t('message.validator.input', { input: this.$t('message.user.legalPersonName').toLowerCase() }),
        },
        {
          key: 'idNumber',
          name: 'message.user.legalPersonNumber',
          type: 'input',
          defValue: '',
          isShowStar: true,
          rule: [REQUIRED],
          maxLength: 18,
          placeholder: this.$t('message.validator.input', { input: this.$t('message.user.legalPersonNumber').toLowerCase() }),
        },
        {
          key: 'expire',
          name: 'message.user.idCardExpire',
          type: 'slot',
          defValue: '',
          isShowStar: true,
        },
        {
          key: 'businessLicense',
          name: 'message.user.businessLicense',
          type: 'input',
          defValue: '',
          isShowStar: true,
          rule: [REQUIRED],
          maxLength: 50,
          placeholder: this.$t('message.validator.input', { input: this.$t('message.user.businessLicense').toLowerCase() }),
        },
        {
          key: 'licenseExpire',
          name: 'message.user.businessLicenseDate',
          type: 'slot',
          defValue: '',
          isShowStar: true,
        },
        {
          key: 'material',
          name: 'message.user.uploadInfo',
          type: 'slot',
          defValue: '',
          isShowStar: true,
        },
      ],
      formData: {
        effectiveDate: '',
        expireDate: '',
        longEffective: false,
        blEffectiveDate: '',
        blExpireDate: '',
        blLongEffective: false,
      },
      materialList: [],
      pickerStartOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      pickerEndOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
    };
  },
  mounted() {
    this.initMethod();
  },
  methods: {
    async initMethod() {
      this.dataLoading = true;
      // 初始化数据
      this.$refs.legalFormRef.assignmentFormValue({ ...this.info });
      this.formData.effectiveDate = this.info.effectiveDate;
      this.formData.longEffective = this.info.expireDate === '2099-01-01';
      if (!this.formData.longEffective) {
        this.formData.expireDate = this.info.expireDate;
      }
      this.formData.blEffectiveDate = this.info.blEffectiveDate;
      this.formData.blLongEffective = this.info.blExpireDate === '2099-01-01';
      if (!this.formData.blLongEffective) {
        this.formData.blExpireDate = this.info.blExpireDate;
      }
      if (!this.info.materialList || this.info.materialList.length === 0) {
        try {
          const res = await getMaterialInfoList({
            businessType: this.info.businessType,
            entityType: 0, // 主体类型，0:企业；1:个人
            registration: this.info.registration,
          });
          const dict = await GlobalData.getDictList(['MATERIAL_NAME']);
          const materialNameUrlList = initSelectedData(dict.MATERIAL_NAME);
          this.materialList = res.map(item => {
            let fileUrl = '';
            const fileList = [];
            if (item.materialUnique) {
              fileUrl = item.fileUrl;
              if (`${item.materialFormat}` !== '2' && item.fileUrl) {
                fileList.push({
                  name: getFileNameFromUrl(item.fileUrl),
                  url: item.fileUrl,
                });
              }
            }
            return {
              ...item,
              label: `${getEnantiomericValue(materialNameUrlList, item.materialName)}${item.required ? '' : `(${this.$t('message.common.optional')})`}`,
              accept: item.materialFormat === '1' ? 'image/png,image/jpeg,image/jpg' : '',
              fileUrl,
              fileList,
            };
          });
          if (this.materialList.length === 0) {
            ShowWarningMessage(this.$t('message.user.failedToObtainTheMaterial'), 6000);
          }
          this.$emit('refresh', { materialList: shallowClones(this.materialList) });
        } catch (err) {

        }
      } else {
        this.materialList = this.info.materialList;
      }
      this.dataLoading = false;
    },
    handleLongEffective(value, type) {
      if (value) {
        if (type === 'blLongEffective') {
          this.formData.blExpireDate = '';
        } else {
          this.formData.expireDate = '';
        }
      }
    },
    onMaterialItemChange(index) {
      return async (event, array) => {
        if (`${this.materialList[index].materialFormat}` === '1' && event.name) {
          const fileName = event.name;
          const fileNameArr = fileName.split('.');
          const ext = fileNameArr[fileNameArr.length - 1].toLowerCase();
          const extList = ['png', 'jpg', 'jpeg', 'bmp'];
          if (extList.indexOf(ext) === -1) { // 不支持格式， 处理兼容性问题
            ShowWarningMessage(this.$t('message.supportFileErrorTip', { type: extList.join(',') }));
            throw new Error(this.$t('message.supportFileErrorTip', { type: extList.join(',') }));
          }
        }
        const isLtM = (event.size / 1024 / 1024) < 50;
        if (!isLtM) {
          const fileSizeTips = `${this.$t('message.validator.fileCannot')}50m`;
          ShowWarningMessage(fileSizeTips);
          throw new Error(fileSizeTips);
        }
        this.dataLoading = true;
        try {
          const res = await uploadMaterialUseTemplate(event.raw);
          this.materialList[index].fileUrl = res;
          this.materialList[index].fileList = [{
            name: event.name,
            url: res,
          }];
        } catch (err) {
        }
        this.dataLoading = false;
      };
    },
    onMaterialItemRemove(index) {
      return async () => {
        this.materialList[index].fileUrl = '';
        this.materialList[index].fileList = [];
      };
    },
    validate() {
      if (!this.formData.effectiveDate) { // 身份证开始时间
        ShowWarningMessage(this.$t('message.searchCommon.startTimeTip', { time: this.$t('message.user.idCardExpire') }));
        return false;
      }
      if (!this.formData.expireDate && !this.formData.longEffective) { // 身份证过期时间
        ShowWarningMessage(this.$t('message.searchCommon.endTimeTip', { time: this.$t('message.user.idCardExpire') }));
        return false;
      }
      if (!this.formData.blEffectiveDate) { // 营业执照开始时间
        ShowWarningMessage(this.$t('message.searchCommon.startTimeTip', { time: this.$t('message.user.businessLicenseDate') }));
        return false;
      }
      if (!this.formData.blExpireDate && !this.formData.blLongEffective) { // 营业执照过期时间
        ShowWarningMessage(this.$t('message.searchCommon.endTimeTip', { time: this.$t('message.user.businessLicenseDate') }));
        return false;
      }
      for (let i = 0; i < this.materialList.length; i++) {
        const material = this.materialList[i];
        if (material.required && !material.fileUrl) {
          ShowWarningMessage(this.$t('message.user.pleaseUploadMaterial'));
          return false;
        }
      }
      return true;
    },
    async submit(check = true) {
      return new Promise((resolve, reject) => {
        const info = {
          materialList: this.materialList,
          effectiveDate: this.formData.effectiveDate ? formatDateDisplay(this.formData.effectiveDate, 'yyyy-MM-dd') : '',
          expireDate: this.formData.longEffective ? '2099-01-01' : (this.formData.expireDate ? formatDateDisplay(this.formData.expireDate, 'yyyy-MM-dd') : ''),
          blEffectiveDate: this.formData.blEffectiveDate ? formatDateDisplay(this.formData.blEffectiveDate, 'yyyy-MM-dd') : '',
          blExpireDate: this.formData.blLongEffective ? '2099-01-01' : (this.formData.blExpireDate ? formatDateDisplay(this.formData.blExpireDate, 'yyyy-MM-dd') : ''),
        };
        if (!check) {
          const params = this.$refs.legalFormRef.getFormJson();
          resolve({
            ...params,
            ...info,
          });
          return;
        }
        this.$refs.legalFormRef.toFormValid((params) => {
          if (!this.validate()) {
            reject(new Error('valid error'));
            return;
          }
          const data = {
            ...params,
            ...info,
          };
          resolve(data);
        }, () => {
          reject(new Error('toFormValid error'));
        });
      });
    },
    async onSubmit() {
      try {
        const res = await this.submit();
        this.$emit('finish', res);
      } catch (err) {
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/element-variables.scss';
.legal-info {
  min-height: 200px;
  .expire-box {
    display: flex;
    align-items: center;

    .rhcn-datepicker {
      width: 140px !important;
    }

    .expire-long-box {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 120px;
      height: 44px;
      background: $color-default;
      border-radius: 4px;
      margin-left: 30px;
    }
  }

  .material-box {
    .material-item {
      position: relative;
      margin-bottom: 15px;
      border-radius: 4px;
      border: 1px solid transparent;

      &.dash-box {
        margin-top: 10px;
        &::before {
          content: '';
          position: absolute;
          top: -10px;
          left: -10px;
          width: 470px;
          height: 114px;
          border-radius: 4px;
          border: 1px dashed #B7C4CE;
          z-index: -1;
        }
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
